<template>
  <v-container>
    <!--(팝업)개인 정보 변경-->
    <v-dialog
      v-model="persondialog" @keydown.esc="persondialog = false"
      max-width="600px"
      persistent>
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          <div class="popCon_txt">
            <v-tabs v-model="tabs" class="popSet_userinfo">
              <v-tab>비밀번호 변경</v-tab>
            </v-tabs>
          </div>
        </v-card-title>
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="popCon">
            <v-tabs-items v-model="tabs">
              <!--비밀번호-->
              <v-tab-item>
                <div class="popCon_txt">현재 사용하는 비밀번호를 입력한 후 새로 사용할 비밀번호를 입력하세요<br>비밀번호는 8자 이상으로 입력해주세요.</div>
                <div class="popCon_input_W100_cov">
                  <v-text-field ref="passwordRules1" class="inputH48_01 conBstar"
                                label="현재 비밀번호"
                                v-model="pass_form.old_password"
                                :rules="rules.passwordRules"
                                type="password"
                                outlined
                                dense
                  >
                  </v-text-field>
                  <v-text-field ref="passwordRules2" class="inputH48_01 conBstar"
                                label="신규 비밀번호"
                                v-model="pass_form.password"
                                :rules="rules.passwordRules"
                                type="password"
                                outlined
                                dense
                  >
                  </v-text-field>
                  <v-text-field ref="passwordRules3" class="inputH48_01 conBstar"
                                label="신규 비밀번호 확인"
                                v-model="pass_form.password_re"
                                type="password"
                                :rules="[(pass_form.password === pass_form.password_re) || '비밀번호가 일치하지않습니다']"
                                outlined
                                dense
                  >
                  </v-text-field>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-row>
        </v-card-text>

        <!--팝업 버튼-->
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card-actions class="justify-center">
              <v-btn class="btn_C01" text @click="changePassword()">확인</v-btn>
              <v-btn text @click="persondialog = false">취소</v-btn>
            </v-card-actions>
          </v-tab-item>
        </v-tabs-items>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>

<script>
  import sha256 from 'sha256'
  import { modifyUserInfo } from '@/api/user'

  export default {
    name: 'changePassword',
    components: {
    },
    props:{
      accountform: {}
    },
    filters: {
      regNumFilter: function (value) {
        if (value) {
          return String(value).replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
        }
      }
    },
    data () {
      return {
        rules: {
          passwordRules: [
            v => !!v || '비밀번호를 입력해 주세요',
            v => /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) || '영어, 숫자 포함하여 6~12자리로 입력해 주십시요'
          ],
        },
        userDelYn: 1,
        persondialog: false,
        tabs: null,
        dialog01: true,
        personform: {
          userid: '',
          name: '',
          email: '',
          addr_main: '',
          phone: ''
        },
        pass_form: {
          old_password: '',
          password: '',
          password_re: ''
        },
        passChangeform: {
          userid: '',
          name: '',
          email: '',
          addr_main: '',
          phone: '',
          old_password: '',
          password: ''
        },
        listParam: {
          page: 0,
          size: 10
        },
        searchData: {
          selectValue: '',
          fromDataValue: '',
          toDataValue: '',
          metaData: [],
          dateChecker: '',
          keyword: []
        },
      }
    },
    created () {
    },
    mounted () {
      this.userid = this.$store.state.user.userid
    },
    methods: {
      open() {
        this.persondialog = true
        this.personform = this.accountform
        this.personform.phone = this.personform.phone.replaceAll('-', '')
      },

      changePassword () {
        if (this.$refs.passwordRules1.validate() && this.$refs.passwordRules2.validate() && this.$refs.passwordRules3.validate()) {
          this.$refs.loading.start('입력 정보 확인 중')
          this.$nextTick(() => {
            // this.passChangeform = this.accountform
            this.passChangeform.userid = this.personform.userid
            this.passChangeform.name = this.personform.name
            this.passChangeform.email = this.personform.email
            this.passChangeform.addr_main = this.personform.addr_main
            this.passChangeform.phone = this.personform.phone

            this.passChangeform.password = sha256(this.pass_form.password)
            this.passChangeform.old_password = sha256(this.pass_form.old_password)
            modifyUserInfo(JSON.stringify({ user: this.passChangeform })).then(Response => {
              if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
                this.$refs.loading.end()
                this.pass_form.password = ''
                this.pass_form.old_password = ''
                this.pass_form.password_re = ''

                this.passChangeform.addr_main = ''
                this.passChangeform.phone = ''
                this.passChangeform.password = ''
                this.passChangeform.old_password = ''
                this.$refs.confirm.open('alert', '개인정보 변경', '비밀번호 변경이 완료되었습니다.')
                this.persondialog = false
              } else {
                this.$refs.loading.end()
                var msg = ''
                if (Response.rdata === undefined) {
                  msg = Response.message
                } else {
                  msg = Response.rdata.message
                }
                this.$refs.confirm.open('alert', '개인정보 변경', msg)
                this.persondialog = false
              }
            })
          })
        } else {
          this.$refs.confirm.open('alert', '개인정보 변경', '비밀번호 형식을 확인 해주세요.')
        }
      }
    }
  }
</script>
